module.exports = __webpack_public_path__ + "static/sylwiawork2-e1e94618ca406f176ed6362552784bcc.jpg";